module.exports = __webpack_public_path__ + "img/icons_attention_mint.d1517bea.svg";